import { RouteRecordRaw } from 'vue-router';
import * as CONST from '@/const'

let routes: RouteRecordRaw[] = [
    {
        path: '/shopProductsConfigs',
        name: 'shopProductsConfigs',
        component: () => import("./views/shopProductsConfigs.vue"),
        meta: {
            allowedRoles: [CONST.AppRoles.SuperAdmin]
        }
    },
    {
        path: '/shopProductConfigDetail/:identifier',
        name: 'shopProductConfigDetail',
        component: () => import("./views/shopProductConfigDetail.vue"),
        meta: {
            allowedRoles: [CONST.AppRoles.SuperAdmin]
        }
    },
];

export default routes;
